import Vue from 'vue'
import Vuex from 'vuex'
import GLOBAL from '@/assets/js/global.js';
// import {getproductByIndex} from '@/data/getdata.js'
  
Vue.use(Vuex)
const key ='token'
const ua = {}
 
const store = new Vuex.Store({
 state(){
   return{
     token:localStorage.getItem('token') ? localStorage.getItem('token'):'',
     account : localStorage.getItem('account') ? JSON.parse(localStorage.getItem('account')):{},
     userinfo : localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')):{},
     login : (localStorage.getItem('userinfo') != '{}' && localStorage.getItem('userinfo')) ? true : false,
     task : [],
     form : {},
     fromType : '0',
     team : [],
     tokeninfo : {},
     cid : 0,
     teamtoke : 0,
     teamdata : {},
     currency : 0,
     currency_team : 0,     
   }
 },
  getters:{
    getSortage:function (state) {
      if(!state.token){
        state.token = localStorage.getItem('token')
      }
      return state.token
    }, 
    getaccount: function(state){
      state.account= localStorage.getItem('account') ? JSON.parse(localStorage.getItem('account')) : {}
      return state.account || {}
    },
    getlogin: function(state){
        state.login = parseInt(localStorage.getItem('login')) ? true : false;
        return state.login
    },
    getuserinfo: function(state){
      state.userinfo = localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : {}
      return state.userinfo
    },          
  },
  mutations:{
   $_setStorage(state,value){
     state.token =value;
     localStorage.setItem('token',value)
   },
   $_setCode(state,value){
    state.code = value;
    localStorage.setItem("code",value)
    },
    $_setShare(state,value){
      state.share =value;
    },       
   $_setAccount(state,account_ua){
     state.account =account_ua
     localStorage.setItem("account",JSON.stringify(account_ua))
   },
   $_setLogin(state,value){
    state.login = value
    localStorage.setItem("login",value)
   },
   $_setAid(state,value){
    state.userinfo.areaId = value;
   },   
   $_setUserinfo(state,value){
    if(typeof value == 'undefined')return;
    state.userinfo = value
    localStorage.setItem("userinfo",JSON.stringify(value))
   },
   $_setCnt(state,value){
    if(typeof value == 'undefined')return;
    state.userinfo.changeCnt += value
   },   
   $_setForm(state,value){
    if(typeof value == 'undefined')return;
    state.form = value
   },
   $_setUsertype(state,value){
    if(typeof value == 'undefined')return;
    state.account.userType= state.account.userType | value
   },
   $_setUserdata(state,value){
    if(typeof value == 'undefined')return;
    state.account.userData[value] = "1"
   },    
   $_setFlag(state,value){
    if(typeof value == 'undefined')return;
    state.account.uflag = state.account.uflag | value

    if((state.account.uflag & 2) == 2){
      state.task[1].finishRate = state.task[0].finishRate;
      state.task[3].finishRate = 1;
    }    
   },
   $_setExp(state,value){
    if(typeof value == 'undefined')return;
    state.account.buy = state.account.buy + value
   },
   $_setRewardStatus(state,value){
    if(typeof value == 'undefined')return;

    state.task[0].giftRate = state.task[0].finishRate;
    if((state.account.uflag & 2) == 2)state.task[1].giftRate = state.task[1].finishRate;
   },
   $_setFinishRate(state,value){
    if(typeof value == 'undefined')return;

    state.task[0].finishRate = Math.floor(value / 100);
    if((state.account.uflag & 2) == 2){
      state.task[1].finishRate = Math.floor(value / 100);
    }
    //console.log(state.task);
   }, 
   $_setWelfareStatus(state,pos){
    if(typeof pos == 'undefined')return;

    state.task[pos].giftRate = (state.task[pos].giftRate + 1);
   },
   $_setBookStatus(state,value){
    state.account.attachData[value] = '1';
   }, 
   $_setScore(state,value){
    if(typeof value == 'undefined')return;
    state.account.score += parseInt(value)

    if(value > 0)state.account.scored += parseInt(value)
   },
   $_setToken(state,value){
    if(typeof value == 'undefined')return;
    state.token = value;
   },
   $_setFrom(state,value){
    if(typeof value == 'undefined')return;
    state.fromType = value;
   },
   $_setTeam(state,value){
    if(typeof value == 'undefined')return;
    state.team = value
   },   
   $_setCid(state,value){
    if(typeof value == 'undefined')return;
    state.cid = value
   },
   $_setTeamtoken(state,value){
    if(typeof value == 'undefined')return;
    state.teamtoken = value
   },
   $_setTeamData(state,value){
    if(typeof value == 'undefined')return;
    state.teamdata = value
   },
   $_setCurrency(state,value){
    if(typeof value == 'undefined')return;
    state.currency = value
   },
   $_setAniFlag(state,value){
    if(typeof value == 'undefined')return;
    state.account.team = value;
   },   
   $_setBuyFlag(state,value){
    if(typeof value == 'undefined')return;
    state.tokeninfo.teamBuyBoon = 1;
   },
   $_setSPFlag(state,value){
    if(typeof value == 'undefined')return;
    state.account.special = value;
   },   
   $_setShareCnt(state,value){
    if(typeof value == 'undefined')return;
    state.account.shareCnt += value;
   },
   $_setSignCnt(state,value){
    if(typeof value == 'undefined')return;
    state.account.signCnt = value;
   },
   $_setCoin(state,value){
    if(typeof value == 'undefined')return;
    state.tokeninfo = value
   },                                    
  },
})
export default store


// WEBPACK FOOTER //
// ./src/assets/js/store.js